import React from 'react'
import { Container } from 'react-bootstrap';
import NeshanMap from './NeshanMap';

function Map() {
  return (
    <Container>
    <NeshanMap
    options={{
      key: "web.jZsJ1ZRvwmhzt0O9kjkihz3m9txx4JomfuMdMGju",
      maptype: "dreamy",
      poi: true,
      traffic: false,
      center: [35.699739, 51.338097],
      zoom: 13,
    }}
    onInit={(L, myMap) => {
      let marker = L.marker([35.699739, 51.338097])
        .addTo(myMap)
        .bindPopup("<b>Hello world!</b><br>I am a popup.");
      myMap.on("click", function (e) {
        marker.setLatLng(e.latlng);
      });

      L.circle([35.699739, 51.348097], {
        color: "red",
        fillColor: "#f03",
        fillOpacity: 0.5,
        radius: 500,
      }).addTo(myMap);
    }}
    style={{width: "100%"}}
  />
  </Container>
  );
}

export default Map;